const OurProcess = () => {
  return (
    <section id="process" className="section-padding">
      <div className="container text-center">
        <h2 className="page-title">
          Our <span className="text-light">Process</span>
        </h2>
      </div>
      <div className="container text-center">
        <div className="row">
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.2s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step1 - Skype Interview"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-headset" />
              </div>
              <h5>Discovery & Analysis</h5>
              <p>
                We begin by understanding your business challenges, current
                systems, and long-term vision. This helps us identify where
                technology can make the most impact.
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.4s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step2 - Project Plan"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-book-pencil" />
              </div>
              <h5>Blueprint</h5>
              <p>
                With insights in hand, we create a detailed technical blueprint.
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.6s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step3 - Design"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-picture-multiple" />
              </div>
              <h5>UI/UX Design</h5>
              <p>
                We then create intuitive design mockups to ensure functionality
                and usability go hand in hand.
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="0.8s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step4 - Development"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-gear" />
              </div>
              <h5>Agile Development</h5>
              <p>
                We follow an agile methodology to deliver features in phases,
                keeping you involved and ensuring fast iterations based on your
                feedback.
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="1s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step5 - Testing"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-ecommerce-graph3" />
              </div>
              <h5>Testing & Deployment</h5>
              <p>
                After rigorous testing, we deploy your system in a live
                environment, managing data migration, integration, and risk
                mitigation.
              </p>
            </div>
          </div>
          <div
            className="process-box col-lg-2 col-md-4 col-sm-6 col-12 wow fadeIn"
            data-wow-delay="1.2s"
            data-wow-duration="2s"
          >
            <div
              className="tipped"
              data-title="Step6 - Delivery"
              data-tipper-options='{"direction":"top"}'
            >
              <div className="process-icon alt-icon-top">
                <i className="icon icon-basic-anticlockwise" />
              </div>
              <h5>Post-Go-Live Support</h5>
              <p>
                Our dedicated support team ensures smooth operations
                post-launch, offering maintenance, performance monitoring, and
                new feature rollouts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
